/**
 * The single-logo display rule (`stores.show_single_logo`, Jake 2026-10-07,
 * a temporary workaround), shared by the storefront PDP logo picker and the
 * cart's logo caption so the two surfaces cannot drift.
 *
 * `count` is how many logos the garment's COLOR offers. Exactly one is not a
 * shopper choice, so it is hidden unless the store explicitly says show (a
 * literal `true`; an absent key reads as the default, off). Two or more are a
 * real choice and are never hidden. Zero or an unknown count has nothing to
 * hide -- callers fall back to showing what they have.
 *
 * Display only: the logo is still selected and recorded on the order.
 */
export function hidesLoneLogo(count, showSingleLogo) {
  return count === 1 && showSingleLogo !== true;
}
